import { render, staticRenderFns } from "./symposiumedit.vue?vue&type=template&id=6e1c864f&scoped=true&"
import script from "./symposiumedit.vue?vue&type=script&lang=js&"
export * from "./symposiumedit.vue?vue&type=script&lang=js&"
import style0 from "./symposiumedit.vue?vue&type=style&index=0&id=6e1c864f&lang=stylus&scoped=true&"
import style1 from "./symposiumedit.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c864f",
  null
  
)

component.options.__file = "symposiumedit.vue"
export default component.exports